//* If you want to put posts associated with the logged in user
//  make a type for POST_POST and add the case below */

import {
  //SET_USER,
  SET_AUTHENTICATED,
  SET_UNAUTHENTICATED,
  //LOADING_USER,
  // LIKE_POST,
  // UNLIKE_POST,
  MARK_NOTIFICATIONS_READ,
  SAVE_POST,
  UNSAVE_POST,
  SET_SAVED_POSTS,
  FOLLOW_USER,
  UNFOLLOW_USER,
  SET_USER
} from "../types";

// initial state of the specific user
const initialState = {
  authenticated: false,
  //loading: false,
  userProfile: {},
  //likes: [],
  notifications: [],
  savedPosts: [],
  following: [],
};

// change the state based on the type change
// action = the actionType we will recieve
export default function (state = initialState, action) {
  switch (action.type) {
    case SET_AUTHENTICATED:
      return {
        ...state,
        authenticated: true,
      };
    case SET_UNAUTHENTICATED:
      return initialState;
    case SET_USER:
      var userProf = action.payload.userProfile;
      const sP = action.payload.userProfile.savedPosts;
      const fo = action.payload.userProfile.following;
      delete userProf.savedPosts;
      delete userProf.followers;
      delete userProf.following;

      //console.log(JSON.stringify(userProf))
      return {
        authenticated: true,
        //loading: false,
        // bind the results using ES6 spread to credentials, likes, and notifs

        userProfile: {...userProf},
        savedPosts: sP,//action.payload.userProfile.savedPosts,
        following: fo, //action.payload.userProfile.following,
        notifications: action.payload.notifications,
        //...action.payload,
      };
    // case LOADING_USER:
    //   return {
    //     ...state,
    //     loading: true,
    //   };
    // case LIKE_POST:
    //   return {
    //     ...state,
    //     likes: [
    //       ...state.likes, action.payload.postId
    //       //{
    //         //userHandle: state.credentials.handle,
    //         //postId: action.payload.postId,
    //       //},
    //     ],
    //   };
    // case UNLIKE_POST:
    //   return {
    //     ...state,
    //     likes: state.likes.filter(
    //       //(like) => like.postId !== action.payload.postId
    //       (postId) => postId !== action.payload.postId
    //     ),
    //   };
      case SAVE_POST:
        //console.log(state.savedPosts)
        state.savedPosts.push(action.payload.postId);

        return {
          ...state,
          // savedPosts: [
          //   ...state.savedPosts, action.payload.postId            
          // ]
          // credentials: {
          //   ...state.credentials,
          //   savedPosts: [
          //     ...state.credentials.savedPosts,              
          //     action.payload.postId,
          //   ],
          // },
        };

      case UNSAVE_POST:
        return {
          ...state,
          // credentials: {
          //   ...state.credentials,
          //   savedPosts: state.credentials.savedPosts.filter(
          //     (post) => post !== action.payload.postId
          //   ),
          // },
          savedPosts: state.savedPosts.filter(
            (post) => post !== action.payload.postId
          ),
        };    

      case SET_SAVED_POSTS:
        return {
          ...state,
          savedPosts: action.payload,
          //loading: false,
        };

      case FOLLOW_USER:        
        
      if(state.following.length === 0) {
        return {
          ...state,
          following: [action.payload.followHandle.user]
        };
      }
        return {
          ...state,
          following: [
            ...state.following, action.payload.followHandle.user
          ]
        };
      
      case UNFOLLOW_USER:
        return {
          ...state,            
          following: state.following.filter(
            (handle) => handle !== action.payload.unfollowHandle
          ),
        }; 

      case MARK_NOTIFICATIONS_READ:
        state.notifications.forEach((not) => (not.read = true));
        return {
          ...state,
        };
      default:
        return state;
  }
}
